// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function getTooltipElem(ele, className) {
  if (ele !== undefined) {
    return React.createElement("div", {
                className: "tooltip-text " + className
              }, ele);
  } else {
    return null;
  }
}

function LabelComponent(Props) {
  var tooltipInfo = Props.tooltipInfo;
  return React.createElement("div", {
              className: "tooltip-base"
            }, getTooltipElem(tooltipInfo.title, "title"), getTooltipElem(tooltipInfo.ts, "ts"), getTooltipElem(tooltipInfo.address, "address"));
}

var make = LabelComponent;

export {
  getTooltipElem ,
  make ,
  
}
/* react Not a pure module */
